const SEPARATORS = /[\s,;]+/;

export function parseDomainsInput(raw: string): string[] {
  const tokens = raw.split(SEPARATORS);
  const seen = new Set<string>();
  const domains: string[] = [];
  for (const token of tokens) {
    const trimmed = token.trim();
    if (trimmed === "") {
      continue;
    }
    if (seen.has(trimmed)) {
      continue;
    }
    seen.add(trimmed);
    domains.push(trimmed);
  }
  return domains;
}
